import styled from 'styled-components'

/** Recreated from ed-components Test/Question.styled (3 lines of CSS). */
export const QuestionContentWrapper = styled.div`
	max-width: 100%;
	width: 100%;
	line-break: auto;
`
